import styled from "styled-components";
import Hero from "src/components/Hero/Hero";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import TitleSection from "src/components/TitleSection/TitleSection";
import { useState } from "react";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";
import SubTitleSection from "src/components/SubTitleSection/SubTitleSection";

const SpinAndSpoilMom2025 = () => {
  const { t, i18n } = useTranslation();
  const [viewBtn, setViewBtn] = useState(false);
  const item = t("spinAndSpoilMom2025.content.dropdownText", {
    returnObjects: true,
  });
  return (
    <Div>
      <Hero
        bgImage="promotions/gaming-machines/spin-and-spoil-mom-2025/mothers-day-hero-image-2400x800px.jpg"
        buttonSettings={null}
        image={`promotions/gaming-machines/spin-and-spoil-mom-2025/mothers-day-logo-2400x2400px-${i18n.language}.png`}
        title={t("spinAndSpoilMom2025.hero.title")}
        descriptionBgColor="#c23c4f"
      ></Hero>
      <EventFinished
        scheduleKeyName="spinAndSpoilMom2025"
        eventType="promotion"
      />
      <MainContentDiv>
        <container-div>
          <TitleSection
            title={t("spinAndSpoilMom2025.content.title")}
            text={t("spinAndSpoilMom2025.content.text")}
            borderColor="#c23c4f"
            dark={true}
          />
          <Row className="g-4 mb-0 mt-0 align-items-center" id="">
            <Col className="mt-0" xs={12} md={12}>
              <ReactMarkdown>
                {t("spinAndSpoilMom2025.content.howItworks")}
              </ReactMarkdown>
              <ReactMarkdown className="mt-5">
                {t("spinAndSpoilMom2025.content.prizes")}
              </ReactMarkdown>
            </Col>
          </Row>

          <Row
            className="g-4 mb-0 mt-0 align-items-center image-container"
            id="buffet"
          >
            <Col className="mt-5" xs={12} md={12}>
              <SubTitleSection
                as="h3"
                subTitle={t("spinAndSpoilMom2025.content.grid.title")}
                text={t("spinAndSpoilMom2025.content.grid.text")}
                borderColor="#c23c4f"
                dark={false}
              />
              <ResponsiveImage
                src={`promotions/gaming-machines/spin-and-spoil-mom-2025/mothers-day-brunch-2400x1600px-${i18n.language}.jpg`}
                alt={t("spinAndSpoilMom2025.hero.title")}
              />
            </Col>
          </Row>

          <Row className="g-4 mb-0 mt-0 align-items-center drop-down-text">
            <button
              onClick={() => {
                item?.list && setViewBtn(!viewBtn);
              }}
            >
              {item.label}
              <span className={viewBtn ? "open" : ""}></span>
            </button>

            <Col xs={12} className={viewBtn ? "ol-active pb-4" : ""}>
              <ReactMarkdown>{item.title}</ReactMarkdown>

              <ol className="rules-list">
                {item.list.map((point, index) => (
                  <li key={index} className={viewBtn ? "ol-active" : ""}>
                    <ReactMarkdown>{point}</ReactMarkdown>

                    {/* Insert table right after item at index 3 */}
                    {index === 3 && item.drawEntries && (
                      <table className="table table-bordered my-3 text-center">
                        <thead className="table-dark">
                          <tr>
                            <th>{item.drawEntries.earningPeriod.title}</th>
                            <th>{item.drawEntries.drawPeriod.title}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{item.drawEntries.earningPeriod.text}</td>
                            <td>{item.drawEntries.drawPeriod.text}</td>
                          </tr>
                        </tbody>
                      </table>
                    )}
                  </li>
                ))}
              </ol>

              <ReactMarkdown>{item.text}</ReactMarkdown>
            </Col>
          </Row>
        </container-div>
      </MainContentDiv>
    </Div>
  );
};

const Div = styled.div`
  width: 100%;
  height: auto;
  .title-section {
    p {
      padding: 0;
      font-size: 20px;
    }
  }
  .hero_text_container {
    /* display: none; */
    /* background-color: rgba(0, 0, 0, 0.1); */
    h1 {
      max-width: 900px;
    }
  }
  .hero_image_container {
    padding: 20px;
  }
  .subtitle-section {
    h2 {
      font-size: 1.8rem;
    }
  }
  strong {
    color: #c23c4f;
  }
`;

const MainContentDiv = styled.div`
  /* background: ${(props) => `url(${props.bgImage})`}; */
  background-color: rgb(232, 235, 239);
  background-position: top;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  container-div {
    background: var(--white);
  }
  @media (min-width: 992px) {
    padding: 3rem 0;
  }
  height: auto;
  width: 100%;
  text-align: left;
  ul {
    list-style: none;
    p {
      margin: 10px 0;
    }
    li {
      white-space: unset;
    }
  }
  .row {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
    .col-12 {
      .subtitle-section {
        @media (min-width: 768px) {
          padding-top: 0;
        }
      }
    }
  }
  .image-container {
    max-width: 1050px;
    margin: 0 auto;
  }
  .drop-down-text {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    button {
      margin: 20px 0;
      width: fit-content;
      max-width: auto;
      border: none;
      height: 40px;
      background-color: #ddd;
      outline: 0;
      color: var(--black);
      border-radius: 0;
      padding: 10px 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      & > span {
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: 10px;
        vertical-align: middle;
        border-top: 4px solid;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        transition: transform 0.3s ease-in-out;
      }

      & > span.open {
        transform: rotate(180deg);
      }
    }
    div {
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-in-out;

      ol {
        padding: 20px;
        margin: 0;

        li {
          padding: 3px;
          font-size: 14px;
          color: #555;
          white-space: normal;
          ul {
            padding-top: 15px;
          }
          p {
            margin: 0;
          }
        }
      }

      &.ol-active {
        max-height: fit-content;
      }
    }
  }
`;

export default SpinAndSpoilMom2025;
